import {Component, OnInit} from '@angular/core';
import {CommonService} from "../../shared/service/common.service";
import {NavigationService} from "../../shared/service/navigation.service";
import {SocialLoginService} from "../../shared/service/social-login.service";
import {AnimationOptions} from "ngx-lottie";

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss']
})
export class LoginPage implements OnInit {

  lottieOptions: AnimationOptions = {
    path: './assets/lottie/city-buildings.json'
  };

  constructor(public commonService: CommonService,
              private navigationService: NavigationService,
              private socialLoginService: SocialLoginService) {
  }

  ngOnInit() {
  }


  loginWithFacebook() {
    this.socialLoginService.loginWithFacebook().then(() => {

    }).catch(err => {
      this.navigationService.closeModal();
    });
  }

  loginWithApple() {
    this.socialLoginService.loginWithApple().then(() => {

    }).catch(err => {
      this.navigationService.closeModal();
    });
  }

  loginWithGoogle() {

    this.socialLoginService.loginWithGoogle().then(() => {
    }).catch(err => {
      this.navigationService.closeModal();
    });
  }

  loginWithMail() {
    this.navigationService.forwardModal('login_mail');
  }

}
